import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
`

export { Container }



// WEBPACK FOOTER //
// ./src/Components/ProfileGroup/styles.js